import { render, staticRenderFns } from "./GeologyRight.vue?vue&type=template&id=c05ef584&scoped=true&"
import script from "./GeologyRight.vue?vue&type=script&lang=js&"
export * from "./GeologyRight.vue?vue&type=script&lang=js&"
import style0 from "./GeologyRight.vue?vue&type=style&index=0&id=c05ef584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05ef584",
  null
  
)

export default component.exports